// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application";

import LayoutController from "./layout_controller";
application.register("layout", LayoutController);

import DialogController from "./dialog_controller";
application.register("dialog", DialogController);

import HotkeysController from "./hotkeys_controller";
application.register("hotkeys", HotkeysController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import TagRulesController from "./tag_rules_controller";
application.register("tag-rules", TagRulesController);

import TagRuleController from "./tag_rule_controller";
application.register("tag-rule", TagRuleController);

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import TaskTitleController from "./task_title_controller";
application.register("task-title", TaskTitleController);

import TaskDragController from "./task_drag_controller";
application.register("task-drag", TaskDragController);

import PostponeController from "./postpone_controller";
application.register("postpone", PostponeController);

import HoneybadgerController from "./honeybadger_controller";
application.register("honeybadger", HoneybadgerController);
